import { UserAccountProps } from 'utils/types';
import { checkIsSetupComplete } from './utils/profileSetup';

export interface AppNavigationPageData {
  page: string;
  date?: string;
}

export const PUBLIC_PAGE_ROUTES = ['RoleSelect', 'Login', 'landing', 'loading', 'Download', 'SignUp0', 'SignUp1_DO', 'SignUp1_Talent'];

export function getFeedbackNavigationGuard(pageData: AppNavigationPageData | null | undefined, allowFeedback: unknown) {
  if (pageData?.page !== 'hygienistFeedback') {
    return { blocked: false, removeFeedbackNav: false };
  }

  if (!allowFeedback) {
    return { blocked: true, removeFeedbackNav: false };
  }

  return { blocked: false, removeFeedbackNav: true };
}

export function getCompletedProfileDefaultRoute(userAccount?: UserAccountProps, pageData?: AppNavigationPageData) {
  if (Number.isInteger(userAccount?.hygienistId) && !!userAccount?.hygienist?.isComplete) {
    const hyg = userAccount?.hygienist;
    const isHygOrAssist = hyg?.type === 0 || hyg?.type === 1;
    const hasNoSkills = !hyg?.skills || hyg.skills.length === 0;
    if (isHygOrAssist && hasNoSkills) {
      return 'forcedQualification';
    }
    if (pageData?.page === 'forcedQualification') return 'hygienistHome';
    return pageData?.page || 'jobPostsList';
  }

  if (Number.isInteger(userAccount?.dentistId) && checkIsSetupComplete(userAccount)) {
    return pageData?.page || 'dentistHome';
  }

  return undefined;
}
